import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Link as CoreLink, Box } from "@miro-site/core";
import HeaderContainer from "./HeaderContainer";
var Link = styled(CoreLink).attrs(function(param) {
    var _theme = param.theme, bottomLinks = _theme.header.bottomLinks;
    return {
        $variant: bottomLinks.link.variant,
        $color: bottomLinks.link.color,
        $size: bottomLinks.link.size,
        withArrow: bottomLinks.link.withArrow,
        $styles: {
            marginRight: bottomLinks.gutter,
            borderBottom: bottomLinks.link.border
        }
    };
}).withConfig({
    componentId: "sc-de6c8eb5-0"
})(_templateObject());
var Wrapper = styled(Box).attrs(function(param) {
    var header = param.theme.header;
    return {
        $styles: {
            height: header.bottomLinks.height,
            paddingTop: header.bottomLinks.paddingTop,
            paddingBottom: header.bottomLinks.paddingBottom,
            borderTop: header.secondaryNavigation.stroke,
            background: header.bottomLinks.background
        }
    };
}).withConfig({
    componentId: "sc-de6c8eb5-1"
})(_templateObject1());
var BottomLinks = function(_param) {
    var bottomLinks = _param.bottomLinks, restProps = _object_without_properties(_param, [
        "bottomLinks"
    ]);
    return /*#__PURE__*/ _jsx(Wrapper, _object_spread_props(_object_spread({}, restProps), {
        children: /*#__PURE__*/ _jsx(HeaderContainer, {
            children: bottomLinks.map(function(l) {
                return /*#__PURE__*/ _jsx(Link, {
                    href: l.path,
                    children: l.title
                }, l.title);
            })
        })
    }));
};
export default Object.assign(BottomLinks, {
    Link: Link
});
